import React from 'react';
import { useNavigate } from 'react-router-dom';
import catalogueStructure from '../data/catalogueStructure';
import CatalogueSidebarCategory from './CatalogueSidebarCategory';
import MobileSubcategoryBar from './MobileSubcategoryBar';

const MobileCategoryChip = ({ cat, isActive, onClick }) => {
  const base = 'px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors';
  const cls = isActive
    ? `${base} bg-orange-500 text-white`
    : cat.highlight
      ? `${base} bg-orange-100 text-orange-600 border border-orange-200`
      : `${base} bg-white text-gray-700 border border-gray-200`;

  return (
    <button onClick={onClick} className={cls} data-testid={`chip-${cat.slug}`}>
      {cat.emoji} {cat.name}
    </button>
  );
};

const CatalogueSidebar = ({
  currentCategory,
  currentSubcategory,
  expandedCategories,
  toggleCategory,
}) => {
  const navigate = useNavigate();

  return (
    <aside className="lg:w-72 flex-shrink-0" data-testid="catalogue-sidebar">
      {/* Mobile: horizontal chip bar - categories */}
      <div className="lg:hidden overflow-x-auto pb-2 -mx-4 px-4">
        <div className="flex gap-2 min-w-max">
          <button
            onClick={() => navigate('/catalogue')}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${!currentCategory ? 'bg-orange-500 text-white' : 'bg-white text-gray-700 border border-gray-200'}`}
            data-testid="chip-all"
          >
            Tous
          </button>
          {catalogueStructure.map((cat) => (
            <MobileCategoryChip
              key={cat.id}
              cat={cat}
              isActive={currentCategory?.id === cat.id}
              onClick={() => navigate(`/catalogue/${cat.slug}`)}
            />
          ))}
        </div>
      </div>

      {/* Mobile: 2nd row - subcategories of active category */}
      <MobileSubcategoryBar
        currentCategory={currentCategory}
        currentSubcategory={currentSubcategory}
      />

      {/* Desktop: tree sidebar */}
      <div className="hidden lg:block bg-white rounded-xl p-6 shadow-sm sticky top-28">
        <h3 className="font-semibold text-gray-900 mb-4">Catégories</h3>
        <nav className="space-y-1">
          <button
            onClick={() => navigate('/catalogue')}
            className={`block w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${!currentCategory ? 'bg-orange-100 text-orange-700 font-medium' : 'text-gray-600 hover:bg-gray-100'}`}
            data-testid="sidebar-all"
          >
            Tous les produits
          </button>

          {catalogueStructure.map((cat) => (
            <CatalogueSidebarCategory
              key={cat.id}
              cat={cat}
              isActiveCategory={currentCategory?.id === cat.id}
              currentSubcategoryId={currentSubcategory?.id}
              isExpanded={expandedCategories.includes(cat.id)}
              onToggle={toggleCategory}
            />
          ))}
        </nav>
      </div>
    </aside>
  );
};

export default CatalogueSidebar;
